import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a8222902"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options" }
const _hoisted_2 = { class: "cfe" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "creation-cfe-title" }, "КПУ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "question" }, [
    /*#__PURE__*/_createElementVNode("span", null, "?")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "question-text" }, " Сумма показателей: кариес, пломбированные, удаленные зубы ")
], -1))
const _hoisted_5 = { class: "cpu-group" }

import { computed, watch } from 'vue'
import { useReportCreation } from '@/widgets/WReportCreation/composables/useReportCreation'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  teethCaries: caries,
  teethFilling: filling,
  teethExtracted: extracted,
} = useReportCreation()

const total = computed(() => {
  return Number(caries.value) + Number(filling.value) + Number(extracted.value)
})

watch([() => caries.value, () => filling.value, () => extracted.value], () => {
  if (caries.value < 0) {
    caries.value = 0
  }
  if (extracted.value < 0) {
    extracted.value = 0
  }
  if (filling.value < 0) {
    filling.value = 0
  }
})
const isCorrect = computed(() => {
  return (
    !(extracted.value > 32 - Math.max(caries.value, filling.value)) ||
    !(caries.value > 32 - extracted.value) ||
    !(filling.value > 32 - extracted.value)
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(total) ? (total).value = $event : null)),
          class: _normalizeClass([{ 'cfe-total-incorrect': !_unref(isCorrect) }, "cfe-total"])
        }, null, 2), [
          [_vModelText, _unref(total)]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          ref: "caries_navigation",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(caries) ? (caries).value = $event : caries = $event)),
          class: "cfe-input",
          maxlength: "2",
          type: "number",
          onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (this.$refs['filling_navigation'].focus()), ["enter"]))
        }, null, 544), [
          [_vModelText, _unref(caries)]
        ]),
        _withDirectives(_createElementVNode("input", {
          ref: "filling_navigation",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(filling) ? (filling).value = $event : filling = $event)),
          class: "cfe-input",
          maxlength: "2",
          type: "number",
          onKeydown: _cache[4] || (_cache[4] = _withKeys(($event: any) => (this.$refs['extracted_navigation'].focus()), ["enter"]))
        }, null, 544), [
          [_vModelText, _unref(filling)]
        ]),
        _withDirectives(_createElementVNode("input", {
          ref: "extracted_navigation",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(extracted) ? (extracted).value = $event : extracted = $event)),
          class: "cfe-input",
          maxlength: "2",
          type: "number"
        }, null, 512), [
          [_vModelText, _unref(extracted)]
        ])
      ])
    ])
  ]))
}
}

})